import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AuthoredEvidence, FormPanel, FormTextField } from '@eas/common-web';

export function Fields() {
  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="ZSD__WORK_ORDER_ATTRIBUTE__DETAIL__PANEL__GENERAL"
            defaultMessage="Všeobecné"
          />
        }
      >
        <FormTextField
          name="name"
          label={
            <FormattedMessage
              id="ZSD__WORK_ORDER_ATTRIBUTE__DETAIL__FIELD_LABEL__NAME"
              defaultMessage="Názov"
            />
          }
          required
        />

        <FormTextField
          name="displayName"
          label={
            <FormattedMessage
              id="ZSD__WORK_ORDER_ATTRIBUTE__DETAIL__FIELD_LABEL__DISPLAY_NAME"
              defaultMessage="Zobrazený názov"
            />
          }
        />

        <AuthoredEvidence.AuthoredFields />
      </FormPanel>
    </>
  );
}
